import { RootState } from "@/store/store";
import { billingExplorerWidgetSetupDataSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/setup/billingExplorerWidgetSetupDataSelector";

export const billingExplorerWidgetSetupPrevCostDateDetailsSelector = (
  state: RootState,
) => {
  return billingExplorerWidgetSetupDataSelector(state)
    ?.previous_period_cost_date_details;
};
